// extracted by mini-css-extract-plugin
module.exports = {"MessageBox":"MessageBox_MessageBox__iYBn3"};